import { render, staticRenderFns } from "./FormItemVoice.vue?vue&type=template&id=311876dc&scoped=true"
import script from "./FormItemVoice.vue?vue&type=script&lang=js"
export * from "./FormItemVoice.vue?vue&type=script&lang=js"
import style0 from "./FormItemVoice.vue?vue&type=style&index=0&id=311876dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311876dc",
  null
  
)

export default component.exports